import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { IApiParams } from '../interface/IApiParams';
import { getCookie, secureToken } from '../utils/utils';
import { getApi } from './getApi';

export const apiGetAllPage = async (section: string, route: string) => {
  const params: IApiParams = {
    url: `/admin/getAllLections.php?section=${section}&route=${route}&${secureToken()}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
